import { render, staticRenderFns } from "./AdminSecurity.vue?vue&type=template&id=27391f7a"
import script from "./AdminSecurity.vue?vue&type=script&lang=js"
export * from "./AdminSecurity.vue?vue&type=script&lang=js"
import style0 from "./AdminSecurity.vue?vue&type=style&index=0&id=27391f7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports